import { getIdQueryString } from '@quromedical/fhir-common';
import {
  PractitionerGetAllResponse,
  PractitionerSearch,
  PractitionerGetOneResponse,
  PractitionerContactUpdateRequest,
  PractitionerGeneralUpdateRequest,
  PractitionerGeneralUpdateResponse,
  QualificationUpdateRequest,
  QualificationUpdateResponse,
  ExternalUpdateResponse,
  SettingsUpdateResponse,
  PartialPractitioner,
  PractitionerUpdateStatus,
  PractitionerCreateRequest,
  PractitionerGetResponse,
  UpdatePractitionerExternal,
  UpdatePractitionerSettings,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class PractitionerApi {
  public activate = async (params: PractitionerUpdateStatus): Promise<PartialPractitioner> => {
    return await trpc.client.practitioner.updateStatus.mutate(params);
  };

  public deactivate = async (params: PractitionerUpdateStatus): Promise<PartialPractitioner> => {
    return await trpc.client.practitioner.updateStatus.mutate(params);
  };

  public async getPractitioner(practitionerId: string): Promise<PractitionerGetOneResponse> {
    return await trpc.client.practitioner.getById.query({ id: practitionerId });
  }

  public async getPractitioners(params: PractitionerSearch): Promise<PractitionerGetAllResponse> {
    return await trpc.client.practitioner.getAll.query(params);
  }

  public async getPractitionersByIds(
    id?: (string | undefined)[]
  ): Promise<PractitionerGetAllResponse> {
    const idQuery = getIdQueryString(id);
    if (!idQuery) {
      return {
        practitioners: [],
      };
    }

    return await trpc.client.practitioner.getAll.query({ id: idQuery });
  }

  public async updatePractitionerContact(
    request: PractitionerContactUpdateRequest
  ): Promise<PractitionerGetOneResponse> {
    const result = await trpc.client.practitioner.updateContact.mutate(request);

    return result;
  }

  public async updatePractitionerGeneral(
    request: PractitionerGeneralUpdateRequest
  ): Promise<PractitionerGeneralUpdateResponse> {
    const result = await trpc.client.practitioner.updateGeneral.mutate(request);

    return result;
  }

  public async createPractitioner(
    practitioner: PractitionerCreateRequest
  ): Promise<PractitionerGetResponse> {
    const result = await trpc.client.practitioner.create.mutate(practitioner);
    return result;
  }

  public async updatePractitionerQualification(
    request: QualificationUpdateRequest
  ): Promise<QualificationUpdateResponse> {
    const result = await trpc.client.practitioner.updateQualification.mutate(request);
    return result;
  }

  public async updatePractitionerExternal(
    request: UpdatePractitionerExternal
  ): Promise<ExternalUpdateResponse> {
    const result = await trpc.client.practitioner.external.mutate(request);
    return result;
  }

  public async updatePractitionerSettings(
    request: UpdatePractitionerSettings
  ): Promise<SettingsUpdateResponse> {
    const result = await trpc.client.practitioner.settings.mutate(request);
    return result;
  }
}
